<template>
  <div id="map" :style="{ height:this.height+'px', width: '100%'}"></div>
</template>

<style scoped>
#map {
  margin: 0 auto;
  background: gray;
}
.h-250 {
  height: 500px;
  width: 700px;
}
#description {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
}

#infowindow-content .title {
  font-weight: bold;
}

#infowindow-content {
  display: none;
}

#map #infowindow-content {
  display: inline;
}

.pac-card {
  margin: 10px 10px 0 0;
  border-radius: 2px 0 0 2px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  outline: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  font-family: Roboto;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 400px;
}

#pac-input:focus {
  border-color: #4d90fe;
}

#title {
  color: #fff;
  background-color: #4d90fe;
  font-size: 25px;
  font-weight: 500;
  padding: 6px 12px;
}
#target {
  width: 345px;
}
</style>  
<script>
import Vue from "vue";
import EventBus from "@/eventBus";
export default {
  props: {
    multiplePosition: {
      type: Array,
      default() {
        return [];
      }
    },
    draggable: {
      type: Boolean,
      default() {
        return false;
      }
    },
    latitude: {
      type: Number,
      default() {
        return EventBus.Province.Phuket[0];
      }
    },
    longitude: {
      type: Number,
      default() {
        return EventBus.Province.Phuket[1];
      }
    },
    zoom: {
      type: Number,
      default() {
        return 11;
      }
    },
    mapType: {
      type: String,
      default() {
        return "clickable";
      }
    },
    width: {
      type: Number,
      default() {
        return 700;
      }
    },
    height: {
      type: Number,
      default() {
        return 500;
      }
    },
    change: {
      type: Number,
      default() {
        return 0;
      }
    }
  },
  watch: {
    change() {
      this.clearMarkers();
      let center_lat = 0;
      let center_long = 0;
      if (
        this.latitude == "" ||
        this.latitude == null ||
        !this.latitude ||
        this.longitude == "" ||
        this.longitude == null ||
        !this.longitude
      ) {
        center_lat = EventBus.Province.Phuket[0];
        center_long = EventBus.Province.Phuket[1];
      } else {
        center_lat = this.latitude;
        center_long = this.longitude;
      }
      this.$map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_long),
        zoom: this.zoom
      });
      this.$markers = [];
      if (this.mapType == "all") {
        this.makeNewMarker();
      }
      this.makeFixedMarker();
    }
  },
  mounted() {
    let center_lat = 0;
    let center_long = 0;
    if (
      this.latitude == "" ||
      this.latitude == null ||
      !this.latitude ||
      this.longitude == "" ||
      this.longitude == null ||
      !this.longitude
    ) {
      center_lat = EventBus.Province.Phuket[0];
      center_long = EventBus.Province.Phuket[1];
    } else {
      center_lat = this.latitude;
      center_long = this.longitude;
    }
    if (this.mapType == "multipleclick") {
      this.$markers = [];
      this.$map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_long),
        zoom: this.zoom
      });
      Vue.nextTick().then(() => {
        this.clearMarkers();
      });
      let vm = this;
      this.$map.addListener("click", function(data) {
        let isIncludes = 0;
        for (let val of vm.$markers) {
          if (
            val.position.lat() == data.latLng.lat() &&
            val.position.lng() == data.latLng.lng()
          ) {
            isIncludes = 1;
            val.setMap(null);
            break;
          }
        }
        if (isIncludes == 0) {
          let marker = vm.makeMarker(data.latLng);
          vm.$markers.push(marker);
          EventBus.$emit("add-marker", {
            latitude: marker.position.lat(),
            longitude: marker.position.lng()
          });
        }
      });
    } else if (this.mapType == "all") {
      this.$map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_long),
        zoom: this.zoom
      });
      this.$markers = [];
      this.makeFixedMarker();
      this.makeNewMarker();
    } else if (this.mapType == "multipleFixed") {
      this.$map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_long),
        zoom: 11
      });
      this.$markers = [];
      this.makeFixedMultipleMarker();
    } else {
      this.$map = new google.maps.Map(document.getElementById("map"), {
        center: new google.maps.LatLng(center_lat, center_long),
        zoom: this.zoom
      });
      this.$markers = [];
      this.makeFixedMarker();
    }
  },
  created() {
    EventBus.$on("clear-markers", () => {
      this.clearMarkers();
      this.$markers = [];
    });
  },
  data() {
    return {
      labels: "123456789",
      labelIndex: 0
    };
  },
  methods: {
    makeNewMarker() {
      let vm = this;
      this.$map.addListener("click", function(data) {
        if (vm.$markers.length != 0) {
          vm.clearMarkers();
        }
        var myLatLng = data.latLng;
        var marker = new google.maps.Marker({
          draggable: vm.draggable,
          position: myLatLng,
          map: vm.$map,
          title: "Hello World!"
        });
        vm.$emit("draged", {
          lat: marker.position.lat(),
          lng: marker.position.lng()
        });
        google.maps.event.addListener(marker, "dragend", function(ev) {
          // alert(myLatLng.lat() + " " + myLatLng.lng()); // always the same LatLng-Object...
          // alert(marker.getPosition());
          vm.$emit("draged", {
            lat: marker.position.lat(),
            lng: marker.position.lng()
          }); // new LatLng-Object after dragend-event...
        });
        vm.$markers.push(marker);
      });
    },
    makeFixedMultipleMarker() {
      for (let key in this.multiplePosition) {
        var myLatLng = new google.maps.LatLng(
          this.multiplePosition[key].latitude,
          this.multiplePosition[key].longitude
        );
        var marker = new google.maps.Marker({
          draggable: this.draggable,
          label: (parseFloat(key) + 1).toString(),
          position: myLatLng,
          map: this.$map,
          title: null
        });
      }
    },
    makeFixedMarker() {
      if (
        (this.latitude != "" ||
          this.latitude != null ||
          this.latitude != NaN) &&
        (this.longitude != "" ||
          this.longitude != null ||
          this.longitude != NaN)
      ) {
        if (this.$markers.length != 0) {
          this.clearMarkers();
        }
        // var myLatLng = { lat: this.latitude, lng: this.longitude };
        var myLatLng = new google.maps.LatLng(this.latitude, this.longitude);
        var marker = new google.maps.Marker({
          draggable: this.draggable,
          position: myLatLng,
          map: this.$map,
          title: "Hello World!"
        });
        let vm = this;
        google.maps.event.addListener(marker, "dragend", function(ev) {
          vm.$emit("draged", {
            lat: marker.position.lat(),
            lng: marker.position.lng()
          });
        });
        this.$markers.push(marker);
      }
    },
    makeMarker(latitude) {
      return new google.maps.Marker({
        draggable: this.draggable,
        label: this.labels[this.labelIndex++ % this.labels.length],
        position: latitude,
        //  icon: {
        //         scaledSize: new google.maps.Size(80, 70)
        //  },
        map: this.$map,
        title: null
      });
    },
    clearMarkers() {
      for (let i = 0; i < this.$markers.length; i++) {
        this.$markers[i].setMap(null);
      }
    }
  }
};
</script>  